import { ComponentProps } from "react";
import { styled } from "~/application/theme";
import { SwitchBase } from "../base/SwitchBase";
import { createSwitchHOC } from "./createSwitchHOC";
import { SwitchButton } from "./SwitchButton";

export type ContainedSwitchProps = ComponentProps<typeof ContainedSwitch>;

const ContainedSwitchRoot = styled(SwitchBase, {
  // Custom
  display: "flex",
  padding: "$4",
  border: "1px solid",
  borderColor: "$neutrals-light",
  borderRadius: "$md",
  backgroundColor: "$neutrals-white",
  transition: "$normal",
  alignItems: "flex-start",

  "&:hover": {
    borderColor: "$primary-base",
  },

  "&[data-checked=true]": {
    backgroundColor: "$primary-light",
    borderColor: "$primary-base",
  },

  "&[data-disabled=true]": {
    opacity: "$disabled",
  },

  [`& > *:focus + ${SwitchButton}`]: {
    boxShadow: "$focus-sm",
  },
});

export const ContainedSwitch = createSwitchHOC(ContainedSwitchRoot);

ContainedSwitch.displayName = "ContainedSwitch";
